import './showhtml.tag'
riot.tag2('email-template-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#settings/email"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;mails&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" if="{!isNew}" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование шаблона письма\'}</div>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="form-group {has-error: error.title}">\n        <label class="control-label">Заголовок</label>\n        <input class="form-control" name="title" type="text" value="{item.title}">\n        <div class="help-block">{error.title}</div>\n      </div>\n      <div class="form-group {has-error: error.subject}">\n        <label class="control-label">Тема письма</label>\n        <input class="form-control" name="subject" type="text" value="{item.subject}">\n        <div class="help-block">{error.subject}</div>\n      </div>\n      <div class="form-group {has-error: error.mailtype}">\n        <label class="control-label">Код письма</label>\n        <input class="form-control" name="mailtype" type="text" value="{item.mailtype}">\n        <div class="help-block">{error.mailtype}</div>\n      </div>\n      <div class="form-group">\n        <label class="control-label">Тело шаблона</label>\n        <textarea class="form-control" name="letter" value="{item.letter}" rows="20"></textarea>\n\n      </div>\n      <div class="form-group">\n        <div class="checkbox-inline">\n          <label>\n            <input type="checkbox" name="isActive" __checked="{item.isActive}">Отправлять шаблон\n          </label>\n        </div>\n      </div>\n      <div class="form-group">\n        <label class="control-label">Вид письма</label>\n        <showhtml value="{item.letter}"></showhtml>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.loader = false;
self.item = {};

self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.rules = {
    title: 'empty',
    subject: 'empty',
    mailtype: 'empty'
};

self.afterChange = function (e) {
    var name = e.target.name;
    delete self.error[name];
    self.error = (0, _extends3.default)({}, self.error, self.validation.validate(self.item, self.rules, name));
};

self.reload = function () {
    observable.trigger('email-edit', self.item.id);
};

self.submit = function (e) {
    var params = self.item;
    self.error = self.validation.validate(params, self.rules);

    if (!self.error) {
        API.request({
            object: 'EmailTemplate',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Шаблон сохранен!', style: 'popup-success' });
                self.item = response;
                self.update();
                if (self.isNew) riot.route('/settings/email/' + self.item.id);
                observable.trigger('email-reload');
            }
        });
    }
};

observable.on('email-edit', function (id) {
    var params = { id: id };
    self.error = false;
    self.isNew = false;
    self.item = {};
    self.loader = true;
    self.update();

    API.request({
        object: 'EmailTemplate',
        method: 'Info',
        data: params,
        success: function success(response, xhr) {
            self.item = response;
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

observable.on('email-new', function () {
    self.error = false;
    self.isNew = true;
    self.item = {};
    self.update();
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/settings/email/email-template-edit.tag